import {Utilities} from '@shared/utilities/utilities.model';

/**
 * Created by wladimir on 17/05/18.
 */


export class NCStatsFilter {
	fields?: string[];
	readers?: string[];

	constructor(model?: any) {
		this.fields = model? model.fields : null;
		this.readers = model? model.readers : null;
	}

	getFilterUrl(): string | null {
		const queryFilter: NCStatsFilter = Object.assign(new NCStatsFilter(), this);
		return Utilities.getQuery(queryFilter);
	}
}
